import AdminConfig from './admin';

import ClientView from './EchartsModule';


export default {
  name : 'echarts',

  type : 'module',
  
  label: 'graphique',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-chart-areaspline',
  }
}